var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 1C9.95576 1 1 9.9513 1 20.9936C1 29.8275 6.73062 37.3219 14.6773 39.9657C15.6768 40.1507 16.0439 39.5319 16.0439 39.0038C16.0439 38.5271 16.0252 36.952 16.0167 35.2814C10.4525 36.4908 9.27845 32.9224 9.27845 32.9224C8.36868 30.6114 7.05783 29.997 7.05783 29.997C5.2433 28.756 7.1946 28.7814 7.1946 28.7814C9.203 28.9226 10.2605 30.8419 10.2605 30.8419C12.0443 33.8985 14.9393 33.0147 16.0806 32.504C16.26 31.2116 16.7784 30.3297 17.3503 29.8305C12.9081 29.3248 8.23818 27.6104 8.23818 19.9495C8.23818 17.7667 9.01948 15.983 10.299 14.5829C10.0913 14.0792 9.40676 12.0458 10.4927 9.29178C10.4927 9.29178 12.1722 8.7544 15.9941 11.3412C17.5894 10.8981 19.3004 10.6761 21.0001 10.6685C22.6998 10.6761 24.412 10.8981 26.0104 11.3412C29.8278 8.7544 31.505 9.29178 31.505 9.29178C32.5936 12.0458 31.9087 14.0792 31.701 14.5829C32.9833 15.983 33.7593 17.7665 33.7593 19.9495C33.7593 27.6286 29.0806 29.3196 24.6271 29.8145C25.3444 30.435 25.9836 31.6518 25.9836 33.517C25.9836 36.1921 25.9604 38.3452 25.9604 39.0038C25.9604 39.5358 26.3204 40.1593 27.3343 39.963C35.2766 37.3163 41 29.8245 41 20.9936C41 9.9513 32.0455 1 21.0001 1Z",
    fill: "#161614"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.7960d77f98d0aa8facf4833acd26d370.svg";
export { ForwardRef as ReactComponent };